module.exports = __webpack_public_path__ + "static/camera8-cffbcd4bd31f4cb85bb7940e3b67abbe.jpg";